import { render, staticRenderFns } from "./base-table-body-cell.vue?vue&type=template&id=60532a68&scoped=true"
import script from "./base-table-body-cell.ts?vue&type=script&lang=js&external"
export * from "./base-table-body-cell.ts?vue&type=script&lang=js&external"
import style0 from "./base-table-body-cell.vue?vue&type=style&index=0&id=60532a68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60532a68",
  null
  
)

export default component.exports